<template>
    <b-card body-class="p-0 mt-3" class="query-filter" title="Filters">
        <b-card-body class="p-0 mt-3">
            <b-row>
                <b-col md="12" cols="12" class="filter-form">
                    <label class="mb-3"><strong>Customer</strong> </label>
                    <customer-type-ahead v-model="filtersModel.customer_id" />
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" cols="12" class="mt-3 dd">
                    <label class="mb-3"><strong>Agent</strong></label>
                    <b-form-select
                        id="input-default-engineer-id"
                        v-model="filtersModel.default_engineer_id"
                        value-field="id"
                        class="form-control"
                        text-field="name"
                        :options="officers"
                    >
                        <template #first>
                            <b-form-select-option :value="null"
                                >Any Officer</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                </b-col>
                <b-col md="6" cols="12" class="mt-3 dd">
                    <label class="mb-3"><strong>Roles</strong>
                    </label>
                        <b-form-select
                            id="input-role-id"
                            v-model="filtersModel.role_id"
                            value-field="id"
                            text-field="name"
                        class="form-control"

                            :options="roles"
                        >
                            <template #first>
                                <b-form-select-option :value="null"
                                    >Select Role</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" cols="12" class="mt-3">
                    <label class="mb-3"><strong>Warranty From</strong>
                    </label>
                        <b-form-input
                            type="date"
                            class="bg-transparent rounded-0"
                            id="input-warranty_from"
                            v-model="filtersModel.warranty_from"
                        ></b-form-input>
                </b-col>
                <b-col md="6" cols="12" class="mt-3">
                    <label class="mb-3"><strong>Warranty To</strong>
                    </label>
                        <b-form-input
                            type="date"
                            id="input-warranty_to"
                            class="bg-transparent rounded-0"
                            v-model="filtersModel.warranty_to"
                        ></b-form-input>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6" cols="12" class="mt-3">
                    <label class="mb-3"><strong>Last Service From</strong>
                    </label>
                        <b-form-input
                            type="date"
                            class="bg-transparent rounded-0"

                            id="input-last_service_from"
                            v-model="filtersModel.last_service_from"
                        ></b-form-input>
                </b-col>

                <b-col md="6" cols="12" class="mt-3">
                    <label class="mb-3"><strong>Last Service From</strong>
                    </label>
                        <b-form-input
                            type="date"
                            class="bg-transparent rounded-0"

                            id="input-last_service_to"
                            v-model="filtersModel.last_service_to"
                        ></b-form-input>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="mt-3">
                    <label class="mb-3"><strong>Next Service From</strong>
                    </label>
                        <b-form-input
                        type="date"
                        class="bg-transparent rounded-0"

                            id="input-next_service_from"
                            v-model="filtersModel.next_service_from"
                        ></b-form-input>
                </b-col>

                <b-col class="mt-3">
                    <label class="mb-3"><strong>Next Service To</strong>
                    </label>
                        <b-form-input
                            type="date"
                            class="bg-transparent rounded-0"

                            id="input-next_service_to"
                            v-model="filtersModel.next_service_to"
                        ></b-form-input>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import CustomerTypeAhead from '@/components/CustomerTypeAhead'

export default {
    name: 'assetSchedule-reportQueryBuilder',
    components: { CustomerTypeAhead },
    data: () => ({}),
    props: ['value', 'crm', 'user', 'officers', 'roles'],

    computed: {
        filtersModel: {
            // getter
            get() {
                return this.value
            },
            // setter
            set(val) {
                this.$emit('input', val)
            },
        },
    },

    watch: {},
}
</script>
